const head = require('./ec-logo.png')
const text = require('./ElephasCareTM.png')

export default function ElephasCareLogo() {
  return <>
    <img src={head} className="h-12" alt="ElephasCare logo"/>
    <img src={text} className="h-12" alt="ElephasCare name and TM"/>
  </>
}
